import Box from "@mui/material/Box";

interface HexScalableTextProps {
  text: string;
  className?: string;
}

/** Scalable 7-char hex ID rendered as SVG with textLength="100%" for exact width fill. */
export function HexScalableText({ text, className }: HexScalableTextProps) {
  const content = (text ?? "").toLowerCase();
  return (
    <Box
      component="svg"
      className={className}
      data-testid="label-short-uuid"
      aria-label={content}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 50 10"
      preserveAspectRatio="xMidYMid meet"
      sx={{ display: "block" }}
    >
      <text
        x="50%"
        y="50%"
        fontFamily="monospace"
        fontWeight="700"
        fontSize="10"
        textAnchor="middle"
        dominantBaseline="central"
        style={{ fill: "currentColor", textTransform: "lowercase" }}
      >
        {content}
      </text>
    </Box>
  );
}
